'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "TagPickerInput", {
    enumerable: true,
    get: function() {
        return TagPickerInput;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _useTagPickerInput = require("./useTagPickerInput");
const _renderTagPickerInput = require("./renderTagPickerInput");
const _useTagPickerInputStylesstyles = require("./useTagPickerInputStyles.styles");
const _reactsharedcontexts = require("@fluentui/react-shared-contexts");
const TagPickerInput = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const state = (0, _useTagPickerInput.useTagPickerInput_unstable)(props, ref);
    (0, _useTagPickerInputStylesstyles.useTagPickerInputStyles_unstable)(state);
    (0, _reactsharedcontexts.useCustomStyleHook_unstable)('useTagPickerInputStyles_unstable')(state);
    return (0, _renderTagPickerInput.renderTagPickerInput_unstable)(state);
});
TagPickerInput.displayName = 'TagPickerInput';
